export const lapalma = {
	nombre: "La Palma",
	dia: "Lunes Santo",
	nombrecompleto:
		"Primera Compañía Espiritual del Santo Rosario y Coro del Ave María, Venerable, Antigua, Ilustre, Franciscana, Lasaliana, Vicenciana, Pontificia y Real Archicofradía Sacramental de Nuestra Señora de La Palma Coronada (Agregada a la del Santísimo Nombre de María de la Corte de Roma) Santísimo Cristo de la Misericordia y María Santísima de las Penas",
	sede: "Parroquia de Ntra. Sra. de La Palma",
	pasos: 2,
	distancia: [2130, 1490],
	penitentes: 290,
	cargadores: 116,
	web: "http://www.diariodecadiz.es/semana_santa/Palma_0_1229277803.html",

	ida: [
		{ lng: -6.3018259, lat: 36.5297034 },
		{ lng: -6.3036713, lat: 36.5297368 },
		{ lng: -6.3036445, lat: 36.5301377 },
		{ lng: -6.302589, lat: 36.530101 },
		{ lng: -6.3023919, lat: 36.5313188 },
		{ lng: -6.3008201, lat: 36.5306113 },
		{ lng: -6.3005438, lat: 36.5312576 },
		{ lng: -6.3001489, lat: 36.5318582 },
		{ lng: -6.2983199, lat: 36.5311278 },
		{ lng: -6.2976093, lat: 36.5309296 },
		{ lng: -6.2974793, lat: 36.53099 },
		{ lng: -6.2971877, lat: 36.5310191 },
		{ lng: -6.2949437, lat: 36.533385 },
		{ lng: -6.2922062, lat: 36.5302864 },
		{ lng: -6.2928097, lat: 36.5297842 },
		{ lng: -6.2945733, lat: 36.5296215 },
		{ lng: -6.2950789, lat: 36.5294696 },
		{ lng: -6.29535, lat: 36.52899 }
	],
	vuelta: [
		{ lng: -6.29535, lat: 36.52899 },
		{ lng: -6.2957011, lat: 36.5290891 },
		{ lng: -6.2954101, lat: 36.5297583 },
		{ lng: -6.295673, lat: 36.5299534 },
		{ lng: -6.295276, lat: 36.5303543 },
		{ lng: -6.2950829, lat: 36.5306991 },
		{ lng: -6.2950172, lat: 36.5308327 },
		{ lng: -6.2949206, lat: 36.5308371 },
		{ lng: -6.294926, lat: 36.531461 },
		{ lng: -6.2964159, lat: 36.5317703 },
		{ lng: -6.29666, lat: 36.5323037 },
		{ lng: -6.2969685, lat: 36.5328188 },
		{ lng: -6.2973949, lat: 36.5325429 },
		{ lng: -6.2979032, lat: 36.5317379 },
		{ lng: -6.2980239, lat: 36.5317724 },
		{ lng: -6.2983136, lat: 36.5311431 },
		{ lng: -6.3001375, lat: 36.5318737 },
		{ lng: -6.3009153, lat: 36.5320817 },
		{ lng: -6.3016127, lat: 36.5309868 },
		{ lng: -6.3021076, lat: 36.5312121 },
		{ lng: -6.3021438, lat: 36.5305321 },
		{ lng: -6.3020901, lat: 36.5305041 },
		{ lng: -6.3021505, lat: 36.5300838 },
		{ lng: -6.302184, lat: 36.5297228 },
		{ lng: -6.3018246, lat: 36.5297195 }
	],
	markers: [
		{
			name: "Salida",
			hora: "2018-03-26T15:45",
			latlng: [36.5297, -6.30182]
		},
		{
			name: "Nueva",
			hora: "2018-03-26T19:30",
			latlng: [36.53062, -6.29249]
		},
		{
			name: "Catedral",
			hora: "2018-03-26T20:30",
			latlng: [36.52899, -6.29535]
		},
		{
			name: "Candelaria",
			hora: "2018-03-26T21:30",
			latlng: [36.53106, -6.295]
		},
		{
			name: "Palillero",
			hora: "2018-03-26T21:55",
			latlng: [36.53196, -6.2965]
		},
		{
			name: "Valverde Barrié",
			hora: "2018-03-26T22:05",
			latlng: [36.53254, -6.29679]
		}
	],
	itinerario: [
		[
			"Virgen de la Palma",
			"San Félix (dcha.)",
			"Corralón de los Carros",
			"Martinez Campos",
			"Rosa (dcha.)",
			"Sagasta (izq.)",
			"Hospital de Mujeres (dcha.)",
			"Plaza la Libertad",
			"Plaza de Topete",
			"Columela",
			"San Francisco (dcha.)",
			"Plaza San Agustín",
			"San Francisco",
			"Nueva"
		],
		[
			"Plaza San Juan de Dios",
			"Pelota",
			"Plaza Pio XII",
			"Estación de Penitencia en la S.I.C."
		],
		[
			"Arquitecto Acero",
			"Plaza de Pío XII",
			"Compañía",
			"Santiago",
			"Plaza Candelaria"
		],
		["Montañés", "Palillero"],
		["Novena"],
		[
			"San Miguel",
			"Alcalá Galiano",
			"Hospital de Mujeres",
			"San Jose",
			"Rosa (dcha.)",
			"Pastora",
			"Plaza Pinto",
			"Hermano Ignacio",
			"Virgen de las Penas",
			"Virgen de la Palma (izq.)"
		]
	],
	mapConfig: {
		center: [36.5311, -6.29721],
		zoom: 17
	}
};



// WEBPACK FOOTER //
// ./src/data/procesiones/lapalma.js